import { render, staticRenderFns } from "./admin.index.vue?vue&type=template&id=f732f018&"
import script from "./admin.index.vue?vue&type=script&lang=js&"
export * from "./admin.index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports